module.exports = __webpack_public_path__ + "static/packaging-c74967d3bb2c89d060371bc4b2c3a7f2.gif";